<template>
  <input-widget
    type="select2"
    :attribute="attribute"
    :items="items"
    :search-handler="handler"
    :options="options"
    :label="label"
    display-field="${item.invoice_no}"
    :hint="hint"
    :model="model"
    :disabled="disabled"
    @select2Select="onSelect"
    @select2Unselect="onUnselect"/>
</template>


<script>
  import InputWidget from "../components/input-widget/InputWidget";
  import InvoicesService from "../../modules/invoices/InvoicesService";

  export default {
    name: "InvoiceSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      options: {
        type: Object,
        default: () => {
          return {minimumInputLength: 1};
        }
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      expand: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      isSearch: {
        type: Boolean,
        default: false,
      },
      extraFilters: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    methods: {
      handler(invoice_no) {
        return InvoicesService.getInvoices({invoice_no, ...this.extraFilters});
      },
      updateItems() {
        if (this.items.length) {
          return;
        }
        const uuid = this.attribute.substr(this.attribute.length - 5, 5);
        if (uuid === '_uuid') {
          let toListenAttribute = this.attribute.substr(0, this.attribute.length - 5);
          if (this.model[toListenAttribute]) {
            this.items.push(this.model[toListenAttribute]);
          }

          this.$watch(`model.${this.attribute}`, function () {
            if (this.model[toListenAttribute] && this.model[toListenAttribute].uuid === this.model[this.attribute]) {
              this.items.push(this.model[toListenAttribute]);
            } else if (!this.model[this.attribute]) {
              if (this.isSearch) {
                this.items.splice(0, this.items.length);
              } else {
                this.items.length = 0;
              }
            }
          }, {deep: true});
        }
      },
      onSelect(data) {
        this.$emit('select', data);
      },
      onUnselect() {
        this.$emit('unselect');
      }
    },
    mounted() {
      this.updateItems();
    }
  }
</script>

<style scoped>

</style>
